<template>
  <div class="time-axis" ref="axisRef"></div>
</template>

<script setup>

  import { onMounted, computed, watch, ref } from 'vue';
  import * as d3 from 'd3';
  import {germanDays, printHeaderHeight, dayMs, createAxisLine, isLastDayOfMonth, getWidthPerDay, daysBetween} from "./planner.js";

  const props = defineProps({ printProject: {type: [Object, null], default: null}, startDate: { type: Date, required: true },endDate:   { type: Date, required: true }});


  const axisRef = ref(null);
  const emit = defineEmits(['deselect'])
  let divAxisPrintHeaderHeight = props.printProject ? printHeaderHeight : 0;

  function renderTimeaxis() {
	  console.log("renderTimeaxis startDate=" + props.startDate)
	  console.log("renderTimeaxis endDate=" + props.endDate)

    const isprintView = props.printProject !== null
    const widthPerDay = getWidthPerDay(isprintView)
    console.log("renderTimeaxis widthPerDay=" + widthPerDay)
	  const startDate = props.startDate;
	  const endDate =  props.endDate;

    axisRef.value.innerHTML = '';
    const totalDays = (props.endDate - props.startDate) / dayMs;
    const x = d3.scaleUtc().domain([props.startDate, props.endDate]).range([0, totalDays * widthPerDay]);

    if (isprintView) {
      let divAxisPrintHeader = document.createElement("div");
      divAxisPrintHeader.classList.add("timeaxis-print-header")
      divAxisPrintHeader.style.height = divAxisPrintHeaderHeight + 'px'
      axisRef.value.appendChild(divAxisPrintHeader)  
    }

    // floor(startDate) ensures we get the 1st of the current month
    // ceil(endDate) ensures we get the 1st of the month AFTER the end
    const monthStart = d3.timeMonth.floor(startDate);
    const monthEnd = d3.timeMonth.ceil(endDate);

    const monthBoundaries = d3.timeMonth.range(monthStart, monthEnd);

    axisRef.value.appendChild(createAxisLine(
      startDate, 
      endDate, 
      monthBoundaries, 
      d3.timeFormat("%b %Y"), 
      (arr, i) => {
        // If next month exists, use it. Otherwise, use endDate.
        let next = arr[i + 1] || endDate;
        // Safety: If the boundary is before the startDate, clamp it to startDate
        return next;
      }, 
      false, 
      isprintView
    ));

    // 1. Force the start date back to the most recent Monday
    const weekStart = d3.timeMonday.floor(startDate);

    // 2. Force the end date forward to the next Monday
    const weekEnd = d3.timeMonday.ceil(endDate);

    // 3. Generate the range using these "snapped" boundaries
    const workWeeks = d3.timeMonday.range(weekStart, weekEnd);

    console.log("workWeeks=" + JSON.stringify(workWeeks))
	  const days = d3.timeDay.range(startDate, endDate);
    axisRef.value.appendChild(createAxisLine(
      startDate, 
      endDate, 
      workWeeks, 
      d3.timeFormat("W%V"), // %V is the ISO week number (standard in Germany)
      (arr, i) => {
        // Simply return the next Monday in the array, or the endDate if last
        return arr[i + 1] || endDate;
      }, 
      false, 
      isprintView
    ));	  
    console.log("days=" + JSON.stringify(days))
	  axisRef.value.appendChild(createAxisLine(startDate, endDate, days, (d) => {return germanDays[d.getDay()]}, null, true, isprintView));
	  axisRef.value.appendChild(createAxisLine(startDate, endDate, days, d3.timeFormat("%d"), null, true, isprintView));
	  axisRef.value.addEventListener("click", function(e) {
      emit('deselect')
    })

    days.forEach(day => {

      const leftPx = x(day) + widthPerDay;
      const sunday = day.getDay() === 1;
	    const isLdm = isLastDayOfMonth(day);

	    if (isLdm || day.getDay() === 0) {

		    let div = document.createElement("div");
		    div.classList.add("highlight")
		    let offset = isLdm ? 2 : 1
		    div.style.left = `${leftPx + offset}px`;
		    div.style.top = "0";
		    div.style.bottom = "0";
		    if (isLdm) {
			    div.classList.add("last_day_month")
          div.style.top = divAxisPrintHeaderHeight + "px";
		    } else {
          div.style.top = (divAxisPrintHeaderHeight + 22) + "px";
			    div.classList.add("last_day_week")
		    }
		    axisRef.value.appendChild(div);
	    }
    });

    console.log("props.printProject=" + JSON.stringify(props.printProject))
    if (!props.printProject) {
      let todayDiv = document.createElement("div");
		  todayDiv.classList.add("today-line-axis")
		  todayDiv.style.left = `${x(new Date())}px`;
      axisRef.value.appendChild(todayDiv);
    }

  }


onMounted(() => {renderTimeaxis();});
</script>
<style>
.time-axis {
  display: flex;
  flex-direction: column;
  background-color: white;
  position: sticky;
  top: 0;
  z-index: 10;
  border-bottom: 1px solid #ccc;
  width: max-content;
}

.time-axis-line {
  display: flex;
  font-size: 12px;
  border-bottom: 1px solid #eee;
  height: 24px;
}

.time-axis-cell {
  flex: none;
  text-align: center;
  padding: 2px 0;
  border-left: 1px solid #eee;
  box-sizing: border-box;
}

.time-axis-cell.printview {
  font-size: 9px;
  font-weight: bold;
}

.highlight {
  position: absolute;
  top: 0;
  bottom: 0;
}

.weekend {
  background-color: rgba(220, 220, 220, 0.4);
}

.holiday {
  background-color: rgba(220, 220, 220, 0.4);
}

.last_day_month {
	border-right: 2px solid gray !important;  
	z-index: 2	 !important;
	pointer-events: none;
}

.last_day_week {
	border-right: 0.25px solid gray !important;  
	z-index: 2	 !important;
	pointer-events: none;
}

.today-line-axis {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 2px;
  background: red;
  z-index: 2;
  pointer-events: none;
}


</style>